<div class="app-container">
  <!--  <modal-status #modalStatus></modal-status>-->
  <page-header
    [icon]="'far-list-alt'"
    [title]="operationTypePage === 'out' ? 'expense' : 'productMoves.load.list'"
    [isStockOperation]="true"
  >
    <ng-container class="header-btn">
      <div class="flex-gap-5 align-items-center">
        <btn
          [label]="operationTypePage === 'in' ? 'product.load' : operationTypePage === 'out' ? 'product.unload' : ''"
          [title]="
            operationTypePage === 'in'
              ? ('product.load' | translate)
              : operationTypePage === 'out'
                ? ('product.unload' | translate)
                : ''
          "
          [icon]="operationTypePage === 'in' ? 'far-layer-plus' : operationTypePage === 'out' ? 'far-layer-minus' : ''"
          [classes]="[
            operationTypePage === 'in'
              ? 'btn-first-green'
              : operationTypePage === 'out'
                ? 'btn-first-red'
                : 'btn-first-orange',
            'btn-sm',
          ]"
          (onEvent)="createStockLoad()"
          *ngIf="!loading && operations.length > 0"
          data-cy="submit-stock-form"
        >
        </btn>
      </div>
      <div class="row d-flex flex-gap-10 ml-0">
        <div *ngIf="operationTypePage === 'in'">
          <div class="form-group mb-0 flex-gap-5 align-items-center">
            <label class="mb-0 text-nowrap">{{ 'depot.to' | translate }}:</label>
            <select
              name="depotSelectTo"
              id="depotSelectTo"
              class="form-control custom"
              [(ngModel)]="selectedDepotTo"
              [disabled]="operations?.length > 0 && !isClonedPmp"
              data-cy="select-depot-to"
            >
              <ng-template ngFor let-depot [ngForOf]="depots">
                <option value="{{ depot.id }}">{{ depot.name }}</option>
              </ng-template>
            </select>
          </div>
        </div>
        <div class="d-flex gap-2rem" *ngIf="operationTypePage === 'out'">
          <div *ngIf="checkouts" class="flex-gap- form-group mb-0 flex-gap-5 align-items-center">
            <label class="mb-0 text-nowrap">{{ 'checkout' | translate }}:</label>
            <select
              name="checkout"
              id="checkout"
              class="form-control custom"
              [ngModel]="selectedCheckout"
              (ngModelChange)="selectedCheckoutChanged($event)"
              [disabled]="operations?.length > 0 && selectedCheckout"
              data-cy="select-checkout"
            >
              <ng-template ngFor let-checkout [ngForOf]="checkouts">
                <option value="{{ checkout.id }}">{{ checkout.name }}</option>
              </ng-template>
            </select>
          </div>
          <div *ngIf="selectedCheckout" class="form-group mb-0 flex-gap-5 align-items-center">
            <label class="mb-0 text-nowrap">{{ 'depotFrom' | translate }}:</label>
            <select
              name="depot"
              id="depotFrom"
              class="form-control custom"
              [ngModel]="selectedDepotFrom"
              (ngModelChange)="depotFromSelected($event)"
              [disabled]="operations?.length > 0"
              data-cy="select-depot-from"
            >
              <ng-template ngFor let-depot [ngForOf]="depots">
                <option value="{{ depot.id }}">{{ depot.name }}</option>
              </ng-template>
            </select>
          </div>
        </div>
      </div>
    </ng-container>
  </page-header>
  <div class="container-fluid">
    <div class="row cards-responsive">
      <div class="col-12 col-sm-12 col-1100 col-lg-6 col-xl-6 pl-0">
        <div class="card mb-0" *ngIf="!isPrintingEANs">
          <div class="row" *ngIf="operationTypePage === 'in' || (operationTypePage === 'out' && selectedDepotFrom)">
            <div class="col-12 col-sm-12">
              <div class="form-group pl-0 pr-0 ml-0 mr-0 pt-2">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchFulltext"
                    (keydown)="filterKeyDown($event)"
                  />
                  <div class="input-group-btn">
                    <button type="button" class="btn-search" (click)="search()" [title]="'filter' | translate">
                      <i class="far fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            *ngIf="!products || (products && products.length === 0 && loading)"
            [ngClass]="{ h150: !products.length && loading }"
          >
            <div class="col-12">
              <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
            </div>
          </div>

          <div
            *ngIf="
              (!products || (products && products.length === 0 && !loading)) &&
              (operationTypePage === 'in' || (operationTypePage === 'out' && selectedDepotFrom))
            "
            class="margin text-center"
            style="padding: 1.625rem"
          >
            {{ 'no.items' | translate }}
          </div>

          <div *ngIf="products && products.length > 0" class="row prod-list-scrolling">
            <div class="col">
              <div class="tableWrapper">
                <table class="table table-responsive" [ngClass]="{ h150: !products.length && loading }">
                  <loading-spinner
                    [isLoading]="loading && ((searchFulltext && searchFulltext.length > 0) || currentPage === 1)"
                    [classesString]="'pt-6'"
                  ></loading-spinner>
                  <div>
                    <thead>
                      <tr>
                        <th class="pl-0">{{ 'product.name' | translate }}</th>
                        <th class="fixed-column-width">&nbsp;</th>
                        <th class="text-center fixed-column-width">{{ 'stock' | translate }}</th>
                        <th class="fixed-column-width">&nbsp;</th>
                      </tr>
                    </thead>
                    <div
                      *ngIf="operationTypePage === 'out' && !selectedDepotFrom && products.length < 1"
                      class="margin text-center"
                      style="padding: 1.625rem"
                    >
                      {{ 'depot.select' | translate }}
                    </div>
                    <tbody class="images" [photoGalleryGroup]="{ index: 1 }">
                      <tr *ngFor="let prod of products">
                        <td class="pl-1 custom-product-td" [ngClass]="{ 'disabled-product': !prod.enabled }">
                          <div class="flex-gap-10 align-items-center">
                            <div
                              [photoGallery]="getThumbUrl(prod.mainImage, 'w2048wp')"
                              [photoGalleryCaption]="
                                prod
                                  ? prod.name +
                                    '<br>' +
                                    (prod.code ? ('stock-operation-list.code' | translate) + prod.code : '') +
                                    '<br>' +
                                    (prod.ean ? ('stock-operation-list.ean' | translate) + prod.ean : '')
                                  : ''
                              "
                            >
                              <div class="images-item">
                                <img class="images-item-image" [src]="getThumbUrl(prod.mainImage)" [alt]="prod.name" />
                              </div>
                            </div>
                            <div>
                              <div>
                                <a class="link-bold product-name-nowrap-wrapper" [routerLink]="['/product', prod.id]">
                                  {{ prod ? prod.name : '' }}
                                </a>
                              </div>
                              <div class="input-group-append flex-wrap product-center">
                                <div class="product-details" *ngIf="prod.code">
                                  {{ 'product.code' | translate }}:<span
                                    [ngClass]="{ 'disabled-product': !prod.enabled }"
                                  >
                                    {{ prod.code }}</span
                                  >
                                </div>
                                <div class="product-details" *ngIf="prod.ean">
                                  {{ 'product.ean' | translate }}:<span
                                    [ngClass]="{ 'disabled-product': !prod.enabled }"
                                  >
                                    {{ prod.ean }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <button
                            *ngIf="isProductExpired(prod)"
                            type="button"
                            class="btn d-flex"
                            tooltip="{{ 'product.expired' | translate }}"
                            placement="left"
                            containerClass="expired-icon"
                          >
                            <img src="../../../assets/img/icons/icon-expired-product.svg" alt="login image" />
                          </button>
                          <div *ngIf="!isProductExpired(prod)">&nbsp;</div>
                        </td>
                        <td class="text-center">
                          {{ getDepotQuantity(prod) }}
                        </td>
                        <td class="pr-1">
                          <div class="flex-gap-10 align-items-center">
                            <div>
                              <modal-stock-operation-card
                                [product]="prod"
                                [depotFrom]="selectedDepotFrom"
                                [depotTo]="selectedDepotTo"
                                [checkout]="selectedCheckout"
                                [type]="operationTypePage"
                                [producers]="producers"
                                [vats]="vats"
                                [suppliers]="suppliers"
                                [depots]="depots"
                                [initDateDUZP]="initDateDUZP"
                                [moves]="operations"
                                (result)="operationListChange($event)"
                                [depotQuantity]="depotQuantity"
                                data-cy="operation-card"
                              >
                              </modal-stock-operation-card>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </table>
              </div>
            </div>
          </div>
          <app-pagination-btn
            *ngIf="(!this.currentPage || this.currentPage <= this.endPage) && this.totalItems > this.products.length"
            (switchPage)="search($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
            [minViewportWidth]="1100"
            [sortDir]="sortDir"
            [sortProp]="sortProp"
            [endPage]="endPage"
            [loadingPage]="loading"
            [currentPage]="currentPage"
          >
          </app-pagination-btn>
        </div>
        <div class="row" *ngIf="isPrintingEANs">
          <div class="col-12">
            <barcode-list-print-array [operations]="operations"></barcode-list-print-array>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-1100 col-lg-6 col-xl-6 pr-0">
        <div class="card mb-0">
          <div class="flex-row">
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.invert'"
              [title]="'select.invert' | translate"
              [icon]="'far-exchange'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('invert')"
            ></btn>
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.none'"
              [title]="'select.none' | translate"
              [icon]="'far-square'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('none')"
            ></btn>
            <btn
              *ngIf="isPrintingEANs"
              [label]="'select.all'"
              [title]="'select.all' | translate"
              [icon]="'far-check-square'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              (onEvent)="printingSelect('all')"
            ></btn>
          </div>
          <div class="row" *ngIf="!isPrintingEANs">
            <div class="col-12 d-flex align-self-center justify-content-between mb-3">
              <div class="card-title text-nowrap" *ngIf="operationTypePage === 'in'" data-cy="batch-title">
                {{ 'stock.load.list' | translate }}
              </div>
              <div class="card-title" *ngIf="operationTypePage === 'out'" data-cy="batch-title">
                {{ 'stock.unload.list' | translate }}
              </div>
              <btn
                [label]="'clear.options'"
                [title]="'clear.options' | translate"
                [icon]="'far-trash-alt'"
                [classes]="['btn-first-red', 'btn-sm']"
                (onEvent)="clearList()"
                *ngIf="!isPrintingEANs && operations && operations.length > 0"
                data-cy="cancel-stock"
              ></btn>
            </div>
          </div>
          <div
            *ngIf="!operations || (operations && operations.length === 0)"
            style="text-align: center; padding: 1.625rem"
          >
            <div class="empty-list">
              <i class="far fa-sad-tear"></i>
              <div>
                {{ 'empty.list' | translate }}
              </div>
            </div>
          </div>
          <div
            class="table-responsive no-print"
            *ngIf="operations?.length > 0"
            [ngClass]="{ 'scrollable-list-short': isPrintingEANs }"
          >
            <table class="width-fill-available m-0">
              <thead>
                <tr>
                  <th *ngIf="isPrintingEANs" class="text-align-center padding-right-05">
                    {{ 'product.printEAN' | translate }}
                  </th>
                  <th>{{ 'product.name' | translate }}</th>
                  <th class="padding-right-05 text-align-center">{{ 'quantity' | translate }}</th>
                  <th *ngIf="operationTypePage !== 'transfer'">
                    {{ 'purchasePrice' | translate }}
                  </th>
                  <th *ngIf="!isPrintingEANs">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let operation of operations">
                  <td *ngIf="isPrintingEANs" class="text-align-center">
                    <input type="checkbox" [(ngModel)]="operation.isEANPrintable" (change)="refreshOperationsHack()" />
                  </td>
                  <td *ngIf="operation.product">
                    <div class="flex-gap-10 align-items-center">
                      <product-image [product]="operation.product"></product-image>
                      <div>
                        <a class="link-bold align-self-center" [routerLink]="['/product', operation.product.id]">
                          {{ operation.product ? operation.product.name : '' }}
                        </a>
                        <div class="flex-column-gap-10 flex-wrap flex-row">
                          <div
                            class="flex-gap-5 flex-wrap product-details"
                            *ngIf="operationTypePage === 'out' && operation.product.supplier"
                          >
                            {{ ('supplier' | translate) + ': ' + operation.product.supplier.name }}
                          </div>
                          <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.product.code">
                            {{ ('product.code' | translate) + ': ' + operation.product.code }}
                          </div>
                          <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.product.ean">
                            {{ ('product.ean' | translate) + ': ' + operation.product.ean }}
                          </div>
                          <div class="flex-gap-5 flex-wrap product-details" *ngIf="operation.batch">
                            {{ !!operation.batch ? ('product.batch' | translate) + ': ' + operation.batch : '' }}
                          </div>
                          <div *ngIf="!!operation.expirationDate" class="flex-gap-5 flex-wrap product-details">
                            {{
                              !!operation.expirationDate
                                ? ('product.expirationDate' | translate) +
                                  ': ' +
                                  (operation.expirationDate | fmtDate: 'dd.MM.yyyy')
                                : ''
                            }}
                          </div>
                          <div
                            class="flex-gap-5 flex-wrap product-details"
                            *ngIf="
                              companyUtil.arePositionsEnabled &&
                              (!!operation.position1 || !!operation.position2 || !!operation.position3)
                            "
                          >
                            {{
                              !!operation.position1 || !!operation.position2 || !!operation.position3
                                ? ('position' | translate) +
                                  ': ' +
                                  operation.position1 +
                                  '-' +
                                  operation.position2 +
                                  '-' +
                                  operation.position3
                                : ''
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="width-max-content text-nowrap text-center">
                    {{ operation.amount || 0 }}
                  </td>
                  <td *ngIf="operationTypePage !== 'transfer'" class="width-max-content text-nowrap">
                    {{ getOperationPrice(operation) | formatPrice: defaultCurrency }}
                  </td>
                  <td *ngIf="!isPrintingEANs" class="pr-1 width-max-content">
                    <div class="flex-gap-5 align-self-center float-right">
                      <modal-stock-operation-card
                        class="d-flex align-items-center"
                        [operationToUpdate]="operation"
                        [product]="operation.product"
                        [depotFrom]="selectedDepotFrom"
                        [depotTo]="selectedDepotTo"
                        [type]="operationTypePage"
                        [producers]="producers"
                        [vats]="vats"
                        [suppliers]="suppliers"
                        [depots]="depots"
                        (result)="updateOperation($event)"
                      >
                      </modal-stock-operation-card>
                      <btn
                        [title]="'delete' | translate"
                        [icon]="'far-trash-alt'"
                        (onEvent)="removeOperation(operation)"
                        [classes]="['btn-sm', 'btn-trash']"
                      >
                      </btn>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="operations?.length && !isPrintingEANs">
                  <td class="no-hover">
                    <strong>{{ 'sum' | translate }}</strong>
                  </td>
                  <td class="text-right text-nowrap no-hover">
                    <div class="flex-gap-10 justify-content-end">
                      <strong>{{ 'bill.quantity' | translate }}: {{ operations | listLength }}</strong>
                      <strong>/</strong>
                      <strong
                        >{{ 'bill.amount' | translate }}: {{ operations | operationsPriceSum: ['quantity'] }}</strong
                      >
                    </div>
                  </td>
                  <td *ngIf="operationTypePage !== 'transfer'" class="text-right text-nowrap no-hover">
                    <strong>{{
                      operations | operationsPriceSum: ['purchase', operationTypePage] | formatPrice: defaultCurrency
                    }}</strong>
                  </td>
                  <td class="no-hover">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-2" *ngIf="!isPrintingEANs">
            <div class="col-12 pl-0 pr-0">
              <div class="operation-list mt-2 advanced">
                <div class="row mb-2" *ngIf="operationTypePage === 'in'">
                  <div class="col-12">
                    <div class="operation-card">
                      <form-row-input
                        [label]="'operationAddedCosts'"
                        [icon]="null"
                        [(model)]="addedCostWithVat"
                        [appendUnitCurrency]="true"
                        [currency]="defaultCurrency"
                        [maxWidthPx]="300"
                        [tooltipIcon]="'fa-info-circle'"
                        [tooltipLabel]="'operationAddedCosts.info'"
                        data-cy="stock-added-costs"
                        class="stock-added-costs"
                      ></form-row-input>
                      <!--                      <div>{{'operationAddedCosts.info' | translate}}</div>-->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="operation-card">
                      <form-row-textarea
                        [label]="'note'"
                        [icon]="null"
                        [model]="note"
                        (modelChange)="updateNote($event)"
                        data-cy="stock-note"
                      ></form-row-textarea>
                    </div>
                  </div>
                </div>
                <div class="operation-card mt-2">
                  <div class="row" *ngIf="uploadedFiles && uploadedFiles.length > 0">
                    <div class="col-12 pr-0">
                      <div class="table-responsive">
                        <table class="w-100">
                          <tbody>
                            <tr *ngFor="let f of uploadedFiles">
                              <td class="pl-1">
                                <div class="flex-gap-10">
                                  <i class="far fa-file-alt align-self-center"></i>
                                  <span class="file-name">{{ f['filename'] }}</span>
                                </div>
                              </td>
                              <td class="pr-1">
                                <btn
                                  [title]="'delete' | translate"
                                  [icon]="'far-trash-alt'"
                                  [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                  (onEvent)="removeUploadedFile(f)"
                                ></btn>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <loading-spinner [isLoading]="areFilesUploading" [classesString]="'top-25'"></loading-spinner>
                      <form-row-input
                        [label]="'files'"
                        [icon]="'far-upload'"
                        [inputType]="'file'"
                        [inputMultiple]="true"
                        (valueChangeNative)="uploadFiles($event)"
                      ></form-row-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
